module.exports = __webpack_public_path__ + "img/logo4.307ec138.jpg";